export const SMS_TEMPLATES = [
  // LEAD
  {
    id: 'sms-new-inquiry-welcome',
    name: 'New Inquiry Welcome',
    description: 'Quick welcome when a lead submits an inquiry.',
    tags: ['Lead', 'New Inquiry'],
    body: "Hi {{FIRST_NAME}}! Thanks for your interest in {{SCHOOL_NAME}}. An advisor will reach out shortly. Reply STOP to opt out.",
  },
  {
    id: 'sms-info-session-reminder',
    name: 'Info Session Reminder',
    description: 'Reminder for an upcoming info session.',
    tags: ['Lead', 'Info Session Booked'],
    body: "Hi {{FIRST_NAME}}, reminder: your {{SCHOOL_NAME}} info session is tomorrow. Reply here with any questions!",
  },
  {
    id: 'sms-application-status',
    name: 'Application Status Update',
    description: 'Let a lead know there is an update on their application.',
    tags: ['Lead', 'Application Started'],
    body: "Hi {{FIRST_NAME}}, there's an update on your {{SCHOOL_NAME}} application. Please check your email or call us back.",
  },
  {
    id: 'sms-lead-followup',
    name: 'Follow Up - No Response',
    description: 'Short nudge when a lead goes quiet.',
    tags: ['Lead', 'Contacted'],
    body: "Hi {{FIRST_NAME}}, still interested in {{SCHOOL_NAME}}? Happy to answer any questions - just text back!",
  },

  // STUDENT
  {
    id: 'sms-class-starting',
    name: 'Class Starting Soon',
    description: 'Remind an enrolled student that class begins soon.',
    tags: ['Student', 'Enrolled'],
    body: "Hi {{FIRST_NAME}}! Your class at {{SCHOOL_NAME}} starts soon. Be sure to check your email for the schedule and first-day details.",
  },
  {
    id: 'sms-payment-reminder',
    name: 'Payment Reminder',
    description: 'Remind a student about an upcoming or missed payment.',
    tags: ['Student', 'Payment Pending'],
    body: "Hi {{FIRST_NAME}}, a payment for your {{SCHOOL_NAME}} program is due. Log in to your account or contact us to make a payment.",
  },
  {
    id: 'sms-document-needed',
    name: 'Document Needed',
    description: 'Prompt student to upload a missing document.',
    tags: ['Student', 'In Progress'],
    body: "Hi {{FIRST_NAME}}, we still need a document to keep your {{SCHOOL_NAME}} enrollment on track. Please upload it at your earliest convenience.",
  },
  {
    id: 'sms-attendance-concern',
    name: 'Attendance Check-In',
    description: 'Reach out after missed class days.',
    tags: ['Student', 'In Progress'],
    body: "Hi {{FIRST_NAME}}, we noticed you missed class. Everything okay? Text back or call us - we want to help you stay on track.",
  },
  {
    id: 'sms-graduation-congrats',
    name: 'Graduation Congrats',
    description: "Celebrate a student's completion.",
    tags: ['Student', 'Graduated'],
    body: "Congrats {{FIRST_NAME}}! You've completed your program at {{SCHOOL_NAME}}. We're so proud of you. Watch for next steps by email.",
  },
  {
    id: 'sms-placement-followup',
    name: 'Placement Follow-Up',
    description: 'Check in with an alum about job placement.',
    tags: ['Student', 'Placed', 'Alumni'],
    body: "Hi {{FIRST_NAME}}, {{SCHOOL_NAME}} here - how's the new role going? Reply anytime, we love hearing from our grads.",
  },

  // EMPLOYER
  {
    id: 'sms-employer-intro',
    name: 'Employer Partnership Intro',
    description: 'First text to a prospective employer partner.',
    tags: ['Employer', 'Prospect'],
    body: "Hi {{FIRST_NAME}}, it's {{SCHOOL_NAME}}. We train healthcare talent and would love to connect about hiring partnerships. Open to a quick chat?",
  },
  {
    id: 'sms-candidate-available',
    name: 'Candidate Available',
    description: 'Let an employer partner know a grad is ready to hire.',
    tags: ['Employer', 'Hiring'],
    body: "Hi {{FIRST_NAME}}, we have a {{SCHOOL_NAME}} grad who'd be a strong fit for your team. Want me to send over their profile?",
  },

  // GENERAL
  {
    id: 'sms-appointment-reminder',
    name: 'Appointment Reminder',
    description: 'Generic reminder for a scheduled call or meeting.',
    tags: ['General'],
    body: "Hi {{FIRST_NAME}}, this is a reminder of your appointment with {{SCHOOL_NAME}}. Reply C to confirm or R to reschedule.",
  },
  {
    id: 'sms-thank-you',
    name: 'Thank You',
    description: 'Short thank-you after a call or meeting.',
    tags: ['General'],
    body: "Thanks for your time today, {{FIRST_NAME}}! Let us know if any questions come up - we're here to help. - {{SCHOOL_NAME}}",
  },
];

export const SMS_TEMPLATE_FILTER_TAGS = ['Lead', 'Student', 'Employer', 'General'];
